<template>
  <div class="container-fluid">
    <div class="block-header position-sticky">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <!-- Beneficiary Details -->
        <div class="card">
          <ValidationObserver v-slot="{ passes }">
            <div class="header border-bottom">
              <h5 class="text-primary font-weight-normal mb-0">
                Edit Receivers Basic Details
              </h5>
            </div>
            <div class="body">
              <form
                @submit.prevent="passes(beneficiarySubmitData)"
                id="basic-form"
              >
                <div class="row">
                  <div class="col-md-4 col-12">
                    <ValidationProvider
                      name="first_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !beneficiary.first_name,
                          success: beneficiary.first_name,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="beneficiary.first_name"
                            class="form-control"
                            id="first_name"
                            placeholder="First Name*"
                          />
                          <label for="first_name" class="control-label">
                            First Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !beneficiary.first_name"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="beneficiary.first_name"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-4 col-12">
                    <div class="form-group">
                      <span class="float-label">
                        <input
                          type="text"
                          class="form-control"
                          id="nickname"
                          v-model="beneficiary.nickname"
                          placeholder="Nick Name"
                        />
                        <label for="nickname" class="control-label">
                          Nick Name
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 col-12">
                    <ValidationProvider
                      name="last_name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !beneficiary.last_name,
                          success: beneficiary.last_name,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="beneficiary.last_name"
                            class="form-control"
                            id="last_name"
                            placeholder="Last Name*"
                          />
                          <label for="last_name" class="control-label">
                            Last Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !beneficiary.last_name"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="beneficiary.last_name"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-4 col-12">
                    <div class="form-group">
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="beneficiary.remitOneid"
                          class="form-control"
                          disabled
                        />
                        <label class="control-label">
                          Remitter Id With Remit One
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 col-12">
                    <ValidationProvider
                      name="relationship"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: beneficiary.relationship && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="relationship">Select Relationship*</label>
                          <multiselect
                            placeholder=""
                            v-model="beneficiary.relationship"
                            :show-labels="false"
                            label="name"
                            :options="relationship_options"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="beneficiary.relationship && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="cancel()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
        <!-- Beneficiary Details -->
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Bank Accounts</h5>
          </div>
          <div class="body">
            <b-table
              table-class="table-custom border"
              head-variant="light"
              :items="
                typeof beneficiaryBankAccounts === 'array' ||
                typeof beneficiaryBankAccounts === 'object'
                  ? beneficiaryBankAccounts
                  : []
              "
              :fields="BankAccountfields"
              responsive
              striped
              hover
              show-empty
            >
              <template #cell(action)="row">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="accountEdit(row.item)">
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item @click="deleteBankAccount(row.item)">
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="editBankAccount"
              size="lg"
              title="Edit Bank Account"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Bank Account
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(editbankSubmitData)">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <ValidationProvider
                          name="bank"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group form-select single-multiselect select-option-custom"
                            :class="{
                              errors: errors[0],
                              success: beneficiary_account.bank && !errors[0],
                            }"
                          >
                            <span class="float-label">
                              <label for="bank">Bank*</label>
                              <multiselect
                                placeholder=""
                                v-model="beneficiary_account.bank"
                                :show-labels="false"
                                :options="bankList"
                                label="bank_name"
                                track-by="id"
                                @select="getBranch($event)"
                              ></multiselect>
                              <i
                                class="fa fa-times"
                                v-if="errors.length && errors[0]"
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="beneficiary_account.bank && !errors[0]"
                              ></i>
                            </span>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider
                          name="branch"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group form-select single-multiselect select-option-custom"
                            :class="{
                              errors: errors[0],
                              success: beneficiary_account.branch && !errors[0],
                            }"
                          >
                            <span class="float-label">
                              <label for="branch">Branch*</label>
                              <multiselect
                                placeholder=""
                                v-model="beneficiary_account.branch"
                                :show-labels="false"
                                :options="bankBranchList"
                                label="branch_name"
                                track-by="id"
                              ></multiselect>
                              <i
                                class="fa fa-times"
                                v-if="errors.length && errors[0]"
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="beneficiary_account.branch && !errors[0]"
                              ></i>
                            </span>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider
                          name="account_number"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group"
                            :class="{
                              errors:
                                errors.length &&
                                !beneficiary_account.account_number,
                              success: beneficiary_account.account_number,
                            }"
                          >
                            <span class="float-label">
                              <input
                                type="text"
                                v-model="beneficiary_account.account_number"
                                class="form-control"
                                id="account_number"
                                placeholder="Last Name*"
                              />
                              <label for="account_number" class="control-label">
                                Account Number*
                              </label>
                              <div class="line"></div>
                              <i
                                class="fa fa-times"
                                v-if="
                                  errors.length &&
                                  !beneficiary_account.account_number
                                "
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="beneficiary_account.account_number"
                              ></i>
                            </span>
                          </div>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-6 col-12">
                        <ValidationProvider
                          name="sort_code"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group form-select single-multiselect select-option-custom"
                            :class="{
                              errors: errors[0],
                              success: beneficiary_account.branch && !errors[0],
                            }"
                          >
                            <span class="float-label">
                              <label for="sort_code">Sort Code</label>
                              <multiselect
                                placeholder=""
                                v-model="beneficiary_account.branch"
                                :show-labels="false"
                                :options="bankBranchList"
                                label="local_code_value"
                                track-by="id"
                              ></multiselect>
                              <i
                                class="fa fa-times"
                                v-if="errors.length && errors[0]"
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="beneficiary_account.branch && !errors[0]"
                              ></i>
                            </span>
                          </div>
                        </ValidationProvider>
                        <div class="form-group">
                          <span class="float-label">
                            <label for="swiftcode">Swift Code</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="beneficiary_account.swiftcode"
                              placeholder="swiftcode"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="sm"
                        @click="closeAccountModel()"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Mobile Money</h5>
          </div>
          <div class="body">
            <b-table
              table-class="table-custom border"
              head-variant="light"
              :items="
                typeof beneficiaryMobile === 'array' ||
                typeof beneficiaryMobile === 'object'
                  ? beneficiaryMobile
                  : []
              "
              :fields="beneficiaryMobilefields"
              responsive
              striped
              hover
              show-empty
            >
              <template #cell(action)="row">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="mobileNetworkEdit(row.item)">
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item @click="deleteMobileMoney(row.item)">
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <b-modal
              id="editMobileNetwork"
              size="lg"
              title="Edit Bank Account"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Mobile Money
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(mobileMoneySubmit)">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <ValidationProvider
                          name="network"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group form-select single-multiselect select-option-custom"
                            :class="{
                              errors: errors[0],
                              success: beneficiary_mobile.network && !errors[0],
                            }"
                          >
                            <span class="float-label">
                              <label for="network">Select Network Name</label>
                              <multiselect
                                placeholder=""
                                v-model="beneficiary_mobile.network"
                                :show-labels="false"
                                :options="network_options"
                                label="name"
                                track-by="id"
                              ></multiselect>
                              <i
                                class="fa fa-times"
                                v-if="errors.length && errors[0]"
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="beneficiary_mobile.network && !errors[0]"
                              ></i>
                            </span>
                          </div>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-6 col-12">
                        <ValidationProvider
                          name="Contact Mobile Number"
                          :rules="'required'"
                          v-slot="{ errors }"
                        >
                          <div
                            class="form-group"
                            :class="{
                              errors: mobileInputError == false || errors,
                              success:
                                beneficiary_mobile.phoneNumber &&
                                mobileInputError,
                            }"
                          >
                            <div
                              class="float-label"
                              v-if="primaryMobileNumber.defaultCountry"
                            >
                              <label for="primary_number" class="control-label">
                                Mobile*
                              </label>
                              <vue-tel-input
                                v-model="beneficiary_mobile.phoneNumber"
                                v-bind="primaryMobileNumber"
                                @validate="mobileInputValidate"
                                ref="telInput"
                                @keydown.native="
                                  restrictSpecialCharacter($event)
                                "
                              >
                                <template v-slot:arrow-icon>
                                  <span class="vti__dropdown-arrow">
                                    {{ "▼" }}
                                  </span>
                                </template>
                              </vue-tel-input>
                              <div class="line"></div>
                              <i
                                class="fa fa-times"
                                v-if="mobileInputError == false"
                              ></i>
                              <i
                                class="fa fa-check"
                                v-if="
                                  mobileInputError &&
                                  beneficiary_mobile.phoneNumber
                                "
                              ></i>
                            </div>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('editMobileNetwork')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-12">
                <div class="card">
                    <div class="header border-bottom d-flex justify-content-between">
                        <h5 class="text-primary font-weight-normal mb-0">Edit Logs</h5>
                    </div>
                    <div class="body">
                        <ul class="list-unstyled mb-0 striped-list">
                            <li class="p-1">
                                <div class="row">
                                    <div class="col-md-4"><span class="font-weight-bold "> Mark Richards</span></div>
                                    <div class="col-md-4">2022-08-19 03:17:41</div>
                                    <div class="col-md-4">Created</div>
                                </div>
                            </li>
                            <li class="p-1">
                                <div class="row">
                                    <div class="col-md-4"><span class="font-weight-bold "> Selena Parker</span></div>
                                    <div class="col-md-4">2022-08-19 06:37:47</div>
                                    <div class="col-md-4">Edited</div>
                                </div>
                            </li>
                            <li class="p-1">
                                <div class="row">
                                    <div class="col-md-4"><span class="font-weight-bold "> Lusifer Boswell</span></div>
                                    <div class="col-md-4">2022-08-19 12:15:28</div>
                                    <div class="col-md-4">Deleted</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
const { VueTelInput } = require("vue-tel-input");
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import {
  GET_BENEFICIARY_DETAILS,
  GET_BENEFICIARY_RELATIONSHIPS,
  UPDATE_BENEFICIARY,
  GET_BANKACCOUNTS,
  GET_MOMOACCOUNTS,
  GET_BANK_BRANCHLIST_BYBANK,
  GET_MOBILE_NETWORKS,
  GET_BANKLIST,
  GET_BANKACCOUNT_DETAILS,
  GET_MOBILE_MONEY_BY_ID,
  UPDATE_BANKACCOUNT_DETALS,
  UPDATE_MOBILE_NETWORKS,
  DELETE_BENEFICIARY_BANKACCOUNT,
  DELETE_BENEFICIARY_MOBILE_MONEY,
} from "../../../store/actions.type.js"; // GET_CUSTOMER_ADDRESS,ADD_MOBILE_NETWORKS
import { ISLOADING } from "../../../store/mutations.type";
import { mapState, mapGetters } from "vuex";
import parsePhoneNumber from "libphonenumber-js";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "EditBeneficiaryComponent",
  components: {
    ValidationObserver,
    ValidationProvider,
    VueTelInput,
    Multiselect: () => import("vue-multiselect"),
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    // Datepicker: () => import('vuejs-datepicker'),
    "main-loader": LoaderComponent,
  },
  data: () => ({
    BankAccountfields: [
      { key: "bank_name", label: "Bank name", sortable: false },
      { key: "branchname", label: "Branch name", sortable: false },
      { key: "account_number", label: "Account number", sortable: false },
      { key: "local_code_value", label: "Sort Code", sortable: false },
      {
        key: "action",
        label: "Action",
        thClass: "th_sortfix text-right pr-4",
        tdClass: "text-right",
      },
    ],
    beneficiaryMobilefields: [
      { key: "networkname", label: "Network Name", sortable: false },
      { key: "phone", label: "Phone Number", sortable: false },
      {
        key: "action",
        label: "Action",
        thClass: "th_sortfix text-right pr-4",
        tdClass: "text-right",
      },
    ],
    relationship_options: [],
    network_options: [],
    beneficiaryBankAccounts: [],
    beneficiaryMobile: [],

    isAllChecked: false,
    isVisible: false,
    bankList: [],
    bankBranchList: [],
    bankSortCode: [],
    bankSwiftCode: [],
    beneficiary: {
      remitOneid: "N/A",
      beneficiary_id: "",
      customer_id: "",
      first_name: "",
      nickname: "",
      last_name: "",
      relationship: null,
    },
    beneficiary_mobile: {
      id: "",
      network: "",
      phoneNumber: "",
    },
    beneficiary_account: {
      bank: [],
      branch: "",
      account_number: "",
      sortcode: "",
      swiftcode: "",
    },
    mobileInputError: "",
    primaryMobileNumber: {
      mode: "auto",
      defaultCountry: " ",
      autoFormat: false,
      dropdownOptions: {
        showFlags: true,
        disabled: true,
        showDialCodeInSelection: true,
      },
    },
    breadCrumbIteams: [
      {
        title: "Receivers",
        links: "",
      },
      {
        title: "Edit Receivers",
        links: "",
      },
    ],
  }),
  methods: {
    // get All Mobile netowrks
    async getAllMobilenetworks(country_id) {
      // let country_id  = this.$CryptoJS.AES.decrypt(this.$route.params?.country_id,'country_id').toString(this.$CryptoJS.enc.Utf8)
      let params = `?sorting=DESC&sortby=created_at&size=700000&page=1&countryid=${country_id}`;
      this.$store.dispatch(GET_MOBILE_NETWORKS, params).then((response) => {
        if (response.status == 200) {
          this.network_options = response.data.details;
        }
      });
    },

    // get beneficiary Mobile wallet
    async getbeneficiaryMobile() {
      let beneficiary_id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.beneficiary_id,
        "beneficiary_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      let customer_id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.customer_id,
        "customer_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      let tempparam = `?beneficiaryId=${beneficiary_id}&customerId=${customer_id}`;
      const tempitems = [];
      await this.$store
        .dispatch(GET_MOMOACCOUNTS, tempparam)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            details.map((item) => {
              let accounts = {
                id: item.id,
                networkname: item.provider_name,
                phone: item.wallet_number,
              };
              tempitems.push(accounts);
            });
          }
          this.beneficiaryMobile = tempitems;
        });
    },

    // Mobile Network details by id
    async mobileNetworkEdit(data) {
      this.emptyBankData();
      this.$store.dispatch(GET_MOBILE_MONEY_BY_ID, data.id).then((response) => {
        if (response.status == 200) {
          let details = response.data.details;
          this.getAllMobilenetworks(details.networkcounryid);
          let mobilenumber = "";
          this.countryList.forEach((element) => {
            if (element.countryid == details.networkcounryid) {
              this.primaryMobileNumber = {
                mode: "auto",
                defaultCountry: element.isocode,
                autoFormat: false,
                dropdownOptions: {
                  showFlags: true,
                  disabled: true,
                  showDialCodeInSelection: true,
                },
              };
              if (details.phone) {
                const phoneNumber = parsePhoneNumber(
                  details.phone,
                  element.isocode,
                );
                if (!phoneNumber) {
                  myFunction.showInfo("Invalid Mobile Number", "error");
                }
                mobilenumber = phoneNumber.nationalNumber;
              }
            }
          });
          setTimeout(() => {
            this.beneficiary_mobile.id = details.id;
            this.beneficiary_mobile.network = this.network_options.filter(
              (item) => item.id === details.networkid,
            )[0];
            this.beneficiary_mobile.phoneNumber = mobilenumber;
          }, 500);
          this.$bvModal.show("editMobileNetwork");
        }
      });
    },

    // Update mobile Money wallet
    mobileMoneySubmit() {
      if (!this.mobileInputError) {
        return;
      }
      let params = {
        id: this.beneficiary_mobile.id,
        networkid: this.beneficiary_mobile.network.id,
        beneficiaryCountryid: this.beneficiary_mobile.network.countryid,
        beneficiaryid: this.$CryptoJS.AES.decrypt(
          this.$route.params?.beneficiary_id,
          "beneficiary_id",
        ).toString(this.$CryptoJS.enc.Utf8),
        phone:
          this.countryList.filter(
            (item) =>
              item.countryid === this.beneficiary_mobile.network.countryid,
          )[0].dialCode + this.beneficiary_mobile.phoneNumber,
        customerid: this.$CryptoJS.AES.decrypt(
          this.$route.params?.customer_id,
          "customer_id",
        ).toString(this.$CryptoJS.enc.Utf8),
      };
      this.$store.dispatch(UPDATE_MOBILE_NETWORKS, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
          this.getbeneficiaryMobile();
          this.$bvModal.hide("editMobileNetwork");
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
      });
    },

    // delete Mobile Money Wallet
    deleteMobileMoney(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to Delete this Mobile Money Wallet!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(DELETE_BENEFICIARY_MOBILE_MONEY, data.id)
              .then((response) => {
                if (response.status == 200) {
                  console.log(response.data);
                  this.getbeneficiaryMobile();
                  myFunction.showInfo(response.data.message, "success");
                }
              });
          }
        });
    },

    // all banks by receivers country
    async getAllbanksbyCountry() {
      // let country_id  = this.$CryptoJS.AES.decrypt(this.$route.params?.country_id,'country_id').toString(this.$CryptoJS.enc.Utf8)
      let params = `?sorting=DESC&sortby=created_at&size=700000&page=1`;
      this.$store.dispatch(GET_BANKLIST, params).then((response) => {
        if (response.status == 200) {
          this.bankList = response.data.details;
        }
      });
    },

    // get beneficiary BankAccounts
    async getbeneficiaryBankAccounts() {
      let beneficiary_id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.beneficiary_id,
        "beneficiary_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      let customer_id = this.$CryptoJS.AES.decrypt(
        this.$route.params?.customer_id,
        "customer_id",
      ).toString(this.$CryptoJS.enc.Utf8);
      let tempparam = `?beneficiaryId=${beneficiary_id}&customerId=${customer_id}`;
      const tempitems = [];
      await this.$store
        .dispatch(GET_BANKACCOUNTS, tempparam)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            details.map((item) => {
              let accounts = {
                id: item.id,
                bank_name: item.bank_name ? item.bank_name : "-",
                branchname: item.branchname ? item.branchname : "-",
                account_number: item.account_number ? item.account_number : "-",
                local_code_value: item.local_code_value
                  ? item.local_code_value
                  : "-",
                bank_code: item.bank_code ? item.bank_code : "-",
              };
              tempitems.push(accounts);
            });
          }
          this.beneficiaryBankAccounts = tempitems;
        });
    },

    // bank account details by id
    async accountEdit(data) {
      this.bankBranchList = [];
      this.emptyBankData();
      await this.getBranch(data);
      this.$store
        .dispatch(GET_BANKACCOUNT_DETAILS, data.id)
        .then((response) => {
          if (response.status == 200) {
            let details = response.data.details;
            if (details) {
              this.beneficiary_account.id = details.id;
              this.beneficiary_account.bank = details.bankid
                ? this.bankList.filter((item) => item.id === details.bankid)[0]
                : " ";
              this.beneficiary_account.branch = details.bank_code
                ? this.bankBranchList.filter(
                    (item) => item.bank_code === details.bank_code,
                  )[0]
                : " ";
              this.beneficiary_account.account_number = details.account_number
                ? details.account_number
                : "";
              this.beneficiary_account.swiftcode = details.swift_code;
            }
            this.$bvModal.show("editBankAccount");
          }
        });
    },

    // bank branch
    async getBranch(data) {
      if (
        data.bankid &&
        this.bankList.filter((item) => item.id === data.bankid).length == 0
      ) {
        return;
      }
      let tempparam = {
        bank_code: data.bank_code,
        params: `?page=1&size=700000&sort=asc&sortby=branch_name`,
      };
      this.beneficiary_account.branch = "";
      await this.$store
        .dispatch(GET_BANK_BRANCHLIST_BYBANK, tempparam)
        .then((response) => {
          if (response.status == 200) {
            this.bankBranchList = response.data.details;
          }
        });
    },

    // Update Bank account
    editbankSubmitData() {
      let params = {
        id: this.beneficiary_account.id,
        beneficiaryid: this.$CryptoJS.AES.decrypt(
          this.$route.params?.beneficiary_id,
          "beneficiary_id",
        ).toString(this.$CryptoJS.enc.Utf8),
        customerid: this.$CryptoJS.AES.decrypt(
          this.$route.params?.customer_id,
          "customer_id",
        ).toString(this.$CryptoJS.enc.Utf8),
        bankid: this.beneficiary_account.bank.id,
        account_number: this.beneficiary_account.account_number,
      };
      this.$store
        .dispatch(UPDATE_BANKACCOUNT_DETALS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.getbeneficiaryBankAccounts();
            this.$bvModal.hide("editBankAccount");
          } else {
            myFunction.showInfo(response.data.message, "error");
          }
        });
    },

    // delete Bank account
    deleteBankAccount(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to Delete this Bank Account!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(DELETE_BENEFICIARY_BANKACCOUNT, data.id)
              .then((response) => {
                if (response.status == 200) {
                  this.getbeneficiaryBankAccounts();
                  myFunction.showInfo(response.data.message, "success");
                }
              });
          }
        });
    },
    emptyBankData() {
      //bank
      this.beneficiary_account.id = "";
      this.beneficiary_account.bank = "";
      this.beneficiary_account.branch = "";
      this.beneficiary_account.account_number = "";
      this.beneficiary_account.swiftcode = "";
      //Mobile
      this.beneficiary_mobile.id = "";
      this.beneficiary_mobile.network = "";
      this.beneficiary_mobile.phoneNumber = "";
    },

    cancel() {
      this.$router.push({ name: "beneficiary-all" });
    },
    closeAccountModel() {
      this.$bvModal.hide("editBankAccount");
    },

    restrictSpecialCharacter(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },

    setPrimaryNumberCountryCode(defaultCountry) {
      this.$refs.telInput.choose(defaultCountry.isocode);
      // localStorage.setItem('countryCode',defaultCountry.isocode);
    },

    mobileInputValidate(phoneObject) {
      this.mobileInputError = phoneObject.valid;
    },

    // get relationships
    async getBeneficiaryrelationships() {
      await this.$store
        .dispatch(GET_BENEFICIARY_RELATIONSHIPS)
        .then((response) => {
          if (response.status == 200) {
            this.relationship_options = response.data.details;
          }
        });
    },

    // Get beneficiary basic Detail
    async beneficiaryDetail() {
      let params = {
        beneficiary_id: this.$CryptoJS.AES.decrypt(
          this.$route.params?.beneficiary_id,
          "beneficiary_id",
        ).toString(this.$CryptoJS.enc.Utf8),
        customer_id: this.$CryptoJS.AES.decrypt(
          this.$route.params?.customer_id,
          "customer_id",
        ).toString(this.$CryptoJS.enc.Utf8),
      };
      this.$store.commit(ISLOADING, true);
      await this.getBeneficiaryrelationships();

      await this.$store
        .dispatch(GET_BENEFICIARY_DETAILS, params)
        .then((response) => {
          if (response.status == 200) {
            const beneficiarydetails = response.data.details;
            this.beneficiary.beneficiary_id = beneficiarydetails.beneficiaryid;
            this.beneficiary.customer_id = beneficiarydetails.customerid;
            this.beneficiary.first_name =
              beneficiarydetails.firstname != null
                ? beneficiarydetails.firstname
                : "";
            this.beneficiary.nickname =
              beneficiarydetails.nickname != null
                ? beneficiarydetails.nickname
                : "";
            this.beneficiary.last_name =
              beneficiarydetails.lastname != null
                ? beneficiarydetails.lastname
                : "";
            this.beneficiary.relationship = this.relationship_options.filter(
              (item) => item.id === beneficiarydetails.relationshipid,
            )[0];
            let customernameBreadcrumbs = [
              {
                title: "Receiver",
                links: "",
              },
              {
                title: "Edit Receiver",
                links: "",
              },
              {
                title:
                  this.beneficiary.first_name +
                  " " +
                  this.beneficiary.last_name,
                links: "",
                isbold: true,
              },
            ];
            this.breadCrumbIteams = customernameBreadcrumbs;
          }
        });
    },

    // update beneficiary basic Submit
    beneficiarySubmitData() {
      let params = {
        beneficiary_id: this.beneficiary.beneficiary_id,
        customer_id: this.beneficiary.customer_id,
        firstname: this.beneficiary.first_name,
        lastname: this.beneficiary.last_name,
        nickname: this.beneficiary.nickname,
        relationshipid: this.beneficiary.relationship.id,
      };
      this.$store.dispatch(UPDATE_BENEFICIARY, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
          this.beneficiaryDetail();
        } else {
          myFunction.showInfo(response.data.message, "error");
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
  async mounted() {
    await this.beneficiaryDetail();
    await this.getbeneficiaryBankAccounts();
    await this.getbeneficiaryMobile();
    await this.getAllbanksbyCountry();
    // await this.getAllMobilenetworks();
  },
};
</script>
